<div
  class="dndContainer"
  [ngClass]="{
    'bg-grey':
      (colorState == 'yellow' && currentState != 'DEFINITION_STATE') ||
      (dndItem.ProgressState === 1 && currentState != 'DEFINITION_STATE'),
    'bg-green':
      (colorState == 'green' && currentState != 'DEFINITION_STATE') ||
      (dndItem.ProgressState === 2 && currentState != 'DEFINITION_STATE')
  }"
>
  <div
    *ngIf="cycle?.EnableWheigthing && referral !== 'MY_STORY'"
    class="weightBox"
    container="body"
    tooltip="{{ 'CYCLE_MANAGER.Weight' | translate }}"
    placement="bottom"
    [adaptivePosition]="true"
    containerClass="backgroundWhite-f dndOkr"
  >
    <i
      class="fa fa-balance-scale color-login-text-one"
      style="font-size: 1.2em"
    ></i>
    <span style="font-size: 1.3em" class="thetextcolor">
      {{
        dndItem.Weight !== null &&
        dndItem.Weight !== undefined &&
        dndItem.Weight !== ''
          ? dndItem.Weight
          : '-'
      }}
    </span>
    <span style="margin-left: 1px" class="thetextcolor">%</span>
  </div>
  <div
    *ngIf="referral === 'MY_STORY'"
    class="podcastBox"
    [ngClass]="{ followed: dndItem.IsFollowedByMe }"
    (click)="follow()"
    container="body"
    containerClass="backgroundWhite-f dndOkr lastCF-tooltip"
    tooltip="{{
      (dndItem.IsFollowedByMe
        ? 'INDIVIDUAL_OBJECTIVES.UnFollow'
        : 'INDIVIDUAL_OBJECTIVES.Follow'
      ) | translate
    }}"
    placement="top"
  >
    <i class="fa fa-podcast small"></i>
  </div>
  <!-- <div class="colorlabel"
    [ngClass]="{'colorlabel-grey': dndItem.ProgressState===0, 'colorlabel-yellow': dndItem.ProgressState===1,'colorlabel-green': dndItem.ProgressState===2}"
    *ngIf="currentState === 'EVALUATION_STATE'" container="body" tooltip="{{getTooltipPhase(dndItem.ProgressState)}}"
    placement="bottom"></div> -->
  <div
    *ngIf="getImage()"
    class="image"
    [ngClass]="{
      grayscale:
        (dndItem.Deferred && dndItem.DeferrType === 'Postpone') ||
        dndItem.Suspended === true
    }"
    [ngStyle]="getImage()"
  >
    <div class="veryBig text-bold revokeBanner" *ngIf="dndItem.Suspended">
      {{ 'Revoked' | translate }}
    </div>
    <div class="veryBig text-bold deferredBanner" *ngIf="isPostponedSource">
      {{ 'Postponed' | translate }}
    </div>
  </div>
  <div
    class="content"
    [ngClass]="{ 'green-text': currentState === 'EXECUTION_STATE' }"
  >
    <div class="title">{{ dndItem.Name }}</div>
    <div class="info display-flex-space-between flex-align-center">
      <div
        class="display-flex-left flex-align-center"
        *ngIf="currentState !== 'EVALUATION_STATE'"
      >
        <div
          class="display-flex-left flex-align-center"
          *ngIf="
            dndItem?.Comments &&
            dndItem?.Comments.length > 0 &&
            referral !== 'MY_STORY'
          "
          container="body"
          tooltip="{{ 'INDIVIDUAL_OBJECTIVES.Comments' | translate }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        >
          <i class="fa fa-comments-o"></i>
          <div class="icon-text">{{ dndItem.Comments.length }}</div>
          <div class="spacer_h"></div>
        </div>

        <!-- http://tools.avaservice.eu/mantisbt/view.php?id=1129 => per il tooltip-->
        <div
          class="display-flex-left flex-align-center"
          container="body"
          tooltip="{{
            (currentState === 'DEFINITION_STATE'
              ? 'INDIVIDUAL_OBJECTIVES.CheckListItems'
              : 'OKR_MEASURES_DASHBOARD.Progress'
            ) | translate
          }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        >
          <i class="fa fa-tasks" aria-hidden="true"></i>
          &nbsp;
          <span *ngIf="currentState === 'DEFINITION_STATE'" class="icon-text">
            {{ dndItem?.CheckList?.length }}
          </span>
          <span *ngIf="currentState === 'EXECUTION_STATE'" class="icon-text">
            {{ getProgress(dndItem) | number: '1.0-0' }}%
          </span>
          <div class="spacer_h"></div>
        </div>

        <div
          class="display-flex-left flex-align-center"
          *ngIf="dndItem?.DueDate"
          container="body"
          tooltip="{{ 'OBJECTIVE_SHEET_POPUP.DueDate' | translate }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        >
          <i class="fa fa-hourglass-end"></i>
          &nbsp;
          <div class="icon-text">{{ dndItem.DueDate | localizedDate }}</div>
        </div>

        &nbsp;

        <!-- Postponed solo Target -->
        <i
          class="fa fa-arrow-right text-green"
          *ngIf="isPostponedTarget && referral !== 'MY_STORY'"
          container="body"
          tooltip="{{
            'PostponedFrom'
              | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
          }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i>
        <!-- Postponed Source -->
        <i
          class="fa fa-info-circle text-green grayscale"
          *ngIf="isPostponedSource"
          container="body"
          tooltip="{{
            'PostponedTo'
              | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
          }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i>
        <!-- Extended Solo Source -->
        <!-- <i
          class="fa fa-calendar-plus-o text-danger"
          *ngIf="isDeferredExtendedSource && referral !== 'MY_STORY'"
          container="body"
          tooltip="{{
            'ExtendedTo' | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
          }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i> -->
        <!-- Extended Solo Target -->
        <!-- <i
          class="fa fa-calendar-minus-o login-btn-color"
          *ngIf="isDeferredExtendedTarget && referral !== 'MY_STORY'"
          container="body"
          tooltip="{{
            'ExtendedFrom'
              | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
          }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i> -->
        <!-- Extended Source & Target -->
        <!-- <div
          class="display-flex-left flex-align-center"
          *ngIf="isDeferredExtendedSourceTarget && referral !== 'MY_STORY'"
        >
          <i
            class="fa fa-calendar-plus-o text-danger"
            container="body"
            tooltip="{{
              'ExtendedTo'
                | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
            }}"
            placement="bottom"
            [adaptivePosition]="true"
            containerClass="backgroundWhite-f dndOkr"
          ></i>
          &nbsp;
          <i
            class="fa fa-calendar-minus-o login-btn-color"
            container="body"
            tooltip="{{
              'ExtendedFrom'
                | translate: { cycle: dndItem?.DeferrInfo?.Cycle.Name }
            }}"
            [adaptivePosition]="true"
            containerClass="backgroundWhite-f dndOkr"
          ></i>
        </div> -->
      </div>

      <div
        class="display-flex-left flex-align-center"
        *ngIf="
          currentState === 'EVALUATION_STATE' &&
          !dndItem.Suspended &&
          !isPostponedSource
        "
      >
        <div
          class="display-flex-left flex-align-center opacity_75"
          container="body"
          tooltip="{{ 'OBJECTIVE_SHEET_POPUP.SelfEvaluation' | translate }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        >
          <i class="fa fa-star footer-default"></i>
          <label class="no-margin">
            <b>
              {{
                dndItem.SelfEvaluationValue && dndItem.SelfEvaluationValue > 0
                  ? dndItem.SelfEvaluationValue
                  : '-'
              }}
            </b>
          </label>
          /
          <label class="no-margin">{{ maxScale }}</label>
        </div>
      </div>

      <div class="display-flex-right flex-align-center">
        <i
          *ngIf="
            coreService.getImageURL(
              dndItem?.Category?.Picture,
              'assets/images/question.png'
            ) == 'assets/images/question.png'
          "
          class="fa fa-question"
          container="body"
          placement="bottom"
          containerClass="backgroundWhite-f dndOkr"
        ></i>
        <img
          *ngIf="
            coreService.getImageURL(
              dndItem?.Category?.Picture,
              'assets/images/question.png'
            ) != 'assets/images/question.png'
          "
          [src]="
            coreService.getImageURL(
              dndItem.Category?.Picture,
              'assets/images/question.png'
            )
          "
          [ngClass]="{
            grayscale: isPostponedSource || dndItem.Suspended === true
          }"
          class="border-complete-rounded"
          container="body"
          tooltip="{{ getTooltip(dndItem?.Category, 'Category') }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr-1"
        />
        <!-- <i
          class="fa fa-question"
          container="body"
          tooltip="{{ getTooltip(dndItem.Visibility, 'Visibility') }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i> -->
        <!-- <img [src]="coreService.getImageURL(dndItem.Category?.Picture,'assets/images/question.png')"
          [ngClass]="{'grayscale': isPostponedSource || dndItem.Suspended === true}"
          container="body" tooltip="{{getTooltip(dndItem.Category,'Category')}}" placement='bottom' [adaptivePosition]="true" containerClass="backgroundWhite-f dndOkr-1"> -->
        <div class="spacer_h"></div>
        <i
          class="fa fa-x visibilityIcon border-complete-rounded"
          [ngClass]="{
            'fa-share-alt': dndItem.Visibility === 'Public',
            'fa-eye-slash': dndItem.Visibility === 'Private',
            'fa-address-book-o': dndItem.Visibility === 'Limited',
            'fa-user-circle-o': dndItem.Visibility === 'Reduced'
          }"
          container="body"
          tooltip="{{ getTooltip(dndItem?.Visibility, 'Visibility') }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        ></i>
        <div class="spacer_h"></div>
        <img
          class="border-complete-rounded"
          [src]="
            coreService.getImageURL(
              dndItem?.Author?.Picture,
              'assets/images/user.jpeg'
            )
          "
          [ngClass]="{
            grayscale: isPostponedSource || dndItem.Suspended === true
          }"
          container="body"
          tooltip="{{ getTooltip(dndItem?.Author, 'Author') | titlecase }}"
          placement="bottom"
          [adaptivePosition]="true"
          containerClass="backgroundWhite-f dndOkr"
        />
      </div>
    </div>
  </div>
  <!-- <div *ngIf="dndItem.Suspended" class="overMessage theRed">{{'Revoked' | translate}}</div> -->
  <!-- <div *ngIf="dndItem.Deferred && dndItem.DeferrType==='Postpone'" class="overMessage theBlue">{{'Postponed' | translate}}</div> -->
  <!-- <div *ngIf="dndItem.Deferred && dndItem.DeferrType==='Extend'" class="overMessage theOrange">{{'Extended' | translate}}</div> -->
  <!--<div *ngIf="dndItem.Deferred === true || dndItem.Suspended === true" class="hoverSuspendedDeferred"></div>-->
</div>
